module.exports = __webpack_public_path__ + "img/UTGOBL-7.559402ec.jpg";